
const ModalSincronizacao = ({
    isOpen, onClose, onConfirm, message,
    startDate, endDate, onDateChange,
    isLoading,
    layouts,           // NOVA PROP
    selectedLayout,    // NOVA PROP
    onLayoutChange     // NOVA PROP
}) => {
    if (!isOpen) return null;

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.modal}>
                <div style={modalStyles.header}>
                    <h3>Sincronização com o banco</h3>
                </div>
                <div style={modalStyles.body}>
                    {isLoading ? (
                        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Sincronizando, aguarde...</p>
                    ) : (
                        <>
                            <p>{message}</p>

                            {/* NOVO CAMPO DE SELEÇÃO DE LAYOUT */}
                            <div style={{ marginBottom: '15px', textAlign: 'left', width: '100%' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                    Banco/Layout:
                                </label>
                                <select
                                    value={selectedLayout}
                                    onChange={(e) => onLayoutChange(e.target.value)}
                                    style={modalStyles.inputField}
                                >
                                    <option value="">Selecione um banco...</option>
                                    {layouts.map(l => (
                                        <option key={l.id} value={l.id}>
                                            {l.banco === '748' ? 'Sicredi' : l.banco === '341' ? 'Itaú' : `Banco ${l.banco}`} - {l.agencia}/{l.conta}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div style={modalStyles.dateInputs}>
                                <label style={{ width: '100%', textAlign: 'left' }}>
                                    Data Inicial:
                                    <input
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => onDateChange('startDate', e.target.value)}
                                        style={modalStyles.inputField}
                                    />
                                </label>
                                <label style={{ width: '100%', textAlign: 'left' }}>
                                    Data Final:
                                    <input
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => onDateChange('endDate', e.target.value)}
                                        style={modalStyles.inputField}
                                    />
                                </label>
                            </div>
                        </>
                    )}
                </div>
                <div style={modalStyles.footer}>
                    <button onClick={onClose} style={modalStyles.buttonCancel} disabled={isLoading}>Cancelar</button>
                    <button
                        onClick={onConfirm}
                        style={{
                            ...modalStyles.buttonConfirm,
                            backgroundColor: (!selectedLayout || isLoading) ? '#ccc' : '#007bff'
                        }}
                        disabled={isLoading || !selectedLayout} // Bloqueia se não escolher layout
                    >
                        {isLoading ? 'Sincronizando...' : 'Confirmar'}
                    </button>
                </div>
            </div>
        </div>
    );

};

const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
    },
    modal: {
        backgroundColor: '#fff',
        padding: '25px',
        borderRadius: '12px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
        width: '420px',
        maxWidth: '95%',
        textAlign: 'center',
        animation: 'fadeIn 0.3s ease'
    },
    header: {
        marginBottom: '20px',
        borderBottom: '1px solid #eee',
        paddingBottom: '15px'
    },
    body: {
        marginBottom: '25px',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        textAlign: 'left' // Melhora a leitura dos labels
    },
    dateInputs: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginTop: '10px'
    },
    inputField: {
        padding: '10px',
        borderRadius: '6px',
        border: '1px solid #d1d5db',
        width: '100%',
        boxSizing: 'border-box',
        marginTop: '5px',
        fontSize: '14px',
        outline: 'none'
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        borderTop: '1px solid #eee',
        paddingTop: '15px'
    },
    buttonConfirm: {
        padding: '10px 20px',
        borderRadius: '6px',
        border: 'none',
        backgroundColor: '#3b82f6',
        color: '#fff',
        cursor: 'pointer',
        fontWeight: '600',
        transition: 'background 0.2s'
    },
    buttonCancel: {
        padding: '10px 20px',
        borderRadius: '6px',
        border: '1px solid #d1d5db',
        backgroundColor: '#fff',
        color: '#374151',
        cursor: 'pointer',
        fontWeight: '500'
    }
};

export default ModalSincronizacao;
